import { module } from 'angular';
import OoAdminComponent from './oo-admin.component';
import ooAdminAttributeEditorComponent from './attribute-editor/oo-admin-attribute-editor.component';
import ooAdminCardReadComponent from './card-read/oo-admin-card-read.component';
import ooAdminHeaderNavbarComponent from './header-navbar/oo-admin-header-navbar.component';
import ooAdminKjsonComponent from './kjson/oo-admin-kjson.component';
import ooAdminKndefComponent from './kndef/oo-admin-kndef.component';
import ooAdminModalInfoComponent from './modal-info/oo-admin-modal-info.component';
import ooAdminObjectsListComponent from './objects-list/oo-admin-objects-list.component';
import ooAdminRelationComponent from './relation/oo-admin-relation.component';
import './oo-admin.scss';

export default module('app')
	.component('ooAdmin', OoAdminComponent)
	.component('ooAdminAttributeEditor', ooAdminAttributeEditorComponent)
	.component('ooAdminCardRead', ooAdminCardReadComponent)
	.component('ooAdminHeaderNavbar', ooAdminHeaderNavbarComponent)
	.component('ooAdminKjson', ooAdminKjsonComponent)
	.component('ooAdminKndef', ooAdminKndefComponent)
	.component('ooAdminModalInfo', ooAdminModalInfoComponent)
	.component('ooAdminObjectsList', ooAdminObjectsListComponent)
	.component('ooAdminRelation', ooAdminRelationComponent)
	.name;
